// extracted by mini-css-extract-plugin
module.exports = {"developmentConsultationsTable":"developmentConsultations_developmentConsultationsTable__hZFJG"};